module.exports = __webpack_public_path__ + "static/3-e8a4b0d8a877a331df9d848f55aea900.jpeg";